module.exports = __webpack_public_path__ + "static/media/classic.cd9a128f.png";